<template>
  <div
    v-if="confirmForgotPasswordErrorKey"
    class="a-transition-fade m-card-primary m-confirm-forgot-password"
  >
      <p class="font-weight-bold text-color-danger text-align-center">
        {{ $t('mConfirmForgotPassword.alerts.error') }}
      </p>
  </div>
  <div
    v-else
    class="a-transition-fade m-card-primary m-confirm-forgot-password"
  >
    <AtomLogoPrimary/>
    <form
      autocomplete="off"
      class="a-form-column"
      name="confirm-forgot-password-form"
      @submit.prevent="createUsuarioConfirmForgotPassword"
    >
      <p class="font-weight-bold text-color-academy-primary text-align-center">
        {{ $t('mConfirmForgotPassword.formInfo') }}
      </p>
      <p class="font-weight-bold text-align-center">
        {{ $t('mConfirmForgotPassword.descripcion') }}
        {{ $route.query.email ? $route.query.email : '' }}
      </p>
      <AtomInputPrimary
        v-model="login.new_password"
        :inputError="$v.login.new_password.$error"
        :messageError="messageErrorNewPassword"
        name="new_password"
        :placeholder="$t('mConfirmForgotPassword.inputs.new_password.placeholder')"
        reference="new_password"
        type="password"
        @blur="$v.login.new_password.$touch()"
      />
      <AtomInputPrimary
        v-model="login.confirm_password"
        :inputError="$v.login.confirm_password.$error"
        :messageError="messageErrorConfirmPassword"
        name="confirm_password"
        :placeholder="$t('mConfirmForgotPassword.inputs.confirm_password.placeholder')"
        reference="confirm_password"
        type="password"
        @blur="$v.login.confirm_password.$touch()"
      />
      <p
        v-if="confirmForgotPasswordError"
        class="font-weight-bold text-color-danger text-align-center"
      >
        {{ $t('mConfirmForgotPassword.alerts.error') }}
      </p>
      <p
        v-if="confirmForgotPasswordSuccess"
        class="font-weight-bold text-color-success text-align-center"
      >
        {{ $t('mConfirmForgotPassword.alerts.success') }}
      </p>
      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeConfirmForgotPassword',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mConfirmForgotPassword.buttonPrimary'),
        behavior: 'login',
        class: 'a-button-login text-transform-uppercase width-100-pr',
        sending: false,
        type: 'submit'
      },

      confirmForgotPasswordError: false,

      confirmForgotPasswordErrorKey: false,

      confirmForgotPasswordSuccess: false,

      login: {
        email: '',
        confirmation_code: '',
        new_password: '',
        confirm_password: ''
      }
    }
  },

  validations: {
    login: {
      confirm_password: {
        sameAsPassword: sameAs('new_password'),
        required
      },

      new_password: {
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          return (containsUppercase && containsLowercase && containsNumber)
        },
        minLength: minLength(8),
        required
      }
    }
  },

  computed: {
    messageErrorConfirmPassword () {
      return this.$validation.getValidationMessage('mConfirmForgotPassword', this.$v.login.confirm_password, 'confirm_password')
    },

    messageErrorNewPassword () {
      return this.$validation.getValidationMessage('mConfirmForgotPassword', this.$v.login.new_password, 'new_password')
    }
  },

  created () {
    this.login.email = this.$route.query.email ? this.$route.query.email : ''
    this.login.confirmation_code = this.$route.query.key ? this.$route.query.key : ''
    if (this.login.email === '' || this.login.confirmation_code === '') {
      this.confirmForgotPasswordErrorKey = true
    }
  },

  methods: {
    createUsuarioConfirmForgotPassword () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.confirmForgotPasswordError = false
        this.confirmForgotPasswordSuccess = false
        this.$services.create('usuario', 'createUsuarioConfirmForgotPassword', this.login)
          .then(response => {
            if (!response.data.error) {
              this.$router.push(`/${this.$t('rPaths.login')}`)
              this.confirmForgotPasswordSuccess = true
            } else {
              this.confirmForgotPasswordError = true
            }
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.confirmForgotPasswordError = true
          })
      }
    }
  }
}
</script>
